import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { StudioProvider } from 'Contexts/StudioContext'
import { Studio } from 'Core/Studio'
import { getPreviewTask, getPreviewTaskForExpert } from 'Services/tasks.service'
import { PAGE_TITLES } from 'Constants/page.constants'
import { ContextType, TaskMode } from 'Types/Tasks.types'
import { useTitle } from 'Hooks/use-title'
import { useUserProfile } from 'shared/auth/hooks/use-user-profile/useUserProfile'
import { useMessage } from 'shared/hooks/use-message'
import { NavigationSource } from 'Constants/constants.ts'

export const OnHoldTaskPreview = () => {
    const [studio, setStudio] = useState<Studio>()
    const { userProfile } = useUserProfile()
    const { taskId } = useParams()
    const [messageApi] = useMessage()
    const [searchParams] = useSearchParams()
    const source = searchParams.get('source')

    useTitle(PAGE_TITLES.ON_HOLD_PREVIEW)

    useEffect(() => {
        async function getTaskDetails() {
            if (!taskId || !userProfile.user.user_id) return
            try {
                const isConsole = source === NavigationSource.INTERNAL

                const details = isConsole
                    ? await getPreviewTask(taskId)
                    : await getPreviewTaskForExpert(taskId, userProfile.user.user_id)

                if (!details) {
                    messageApi.error('Failed to load the task feedback preview. Please try again')
                    console.error('Failed to load the task feedback preview. Please try again')
                    return
                }
                setStudio(
                    new Studio({
                        taskType: details?.assignmentResp?.assignment.task.type,
                        interfaceKey: details?.assignmentResp?.assignment.interface_key,
                        taskConfig: {
                            taskId,
                            assignment: details?.assignmentResp?.assignment,
                            submissionId: 'MockSubmissionId',
                            mode: TaskMode.TaskViewer,
                        },
                        context: {
                            type: ContextType.NormalTask,
                        },
                        pluginsConfig: [],
                        onNextTask: () => {},
                        onExitTask: () => {},
                    })
                )
            } catch (error) {
                messageApi.error('Error fetching TaskPreview')
            }
        }

        if (!studio) {
            getTaskDetails()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!studio) {
        // might want to render a loading state here if needed
        return null
    }

    return (
        <div data-testid="task-preview-wrapper">
            <StudioProvider value={studio}>{studio.workbench.element}</StudioProvider>
        </div>
    )
}
